module.exports = __webpack_public_path__ + "static/media/ezgif-1-997e5035cba4.fd8e07e1.png";